<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2>Importer / Exporter le référentiel entreprises</h2>

        <b-col cols="10">
            <b-row class="mt-3">
                <b-col cols="1" offset="11">
                    <b-button type="button" variant="success" @click="exporter">Exporter</b-button>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col cols="11">
                    <b-form-file
                            v-model="importFile"
                            placeholder="Choisir un fichier pour import"
                            drop-placeholder="Déposer le fichier ici"
                            browse-text="Importer un fichier"
                            accept=".csv"
                    ></b-form-file>
                </b-col>
                <b-col cols="1">
                    <b-button type="button" variant="success" @click="importer" :disabled="!importFile">Importer
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
    </div>
</template>

<script>

  import EntrepriseStore from "../../stores/EntrepriseStore";
  import AlertStore from "../../stores/AlertStore";
  import FileUtil from "../../utils/fileUtil";

  export default {
    data() {
      return {
        importFile: null
      }
    },
    methods: {
      exporter() {
        EntrepriseStore.export().then(
            result => {
              FileUtil.downloadFile(result.data, 'text/csv;charset=utf8;');
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      importer() {
        EntrepriseStore.import(this.importFile).then(
            result => {
              if (result.data.fileName.includes('erreur')) {
                AlertStore.pushWarning("Le fichier importé comporte des erreurs, veuillez consulter le rapport d'erreur");
              } else {
                AlertStore.pushSuccess("Fichier d'entreprises importé avec succès");
              }
              FileUtil.downloadFile(result.data, 'text/csv;charset=utf8;');
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      }
    }
  }
</script>
